import { Tooltip } from "antd";
import RemoveIcon from "@mui/icons-material/Remove";
import { BsChatLeftText } from "react-icons/bs";
import { IoHomeOutline } from "react-icons/io5";
import { useState } from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import { MdChat } from "react-icons/md";

const BrandDiv = ({ bgcolor, headerLable, widgetPosition }) => {
  const [newHovered, setnewHovered] = useState(false);

  return (
    <div
      className="chatboxView"
      style={{
        justifyContent: widgetPosition || "center",
        width: "100%",
      }}
    >
      <div
        className="chat-window2"
        id="chat-window2"
        style={{
          backgroundColor: `${bgcolor}`,
          width: "100%",
          maxWidth: 400,
          height: 545,
          borderRadius: 12,
          boxShadow: "0 5px 20px rgba(0, 0, 0, 0.2)",
          backgroundImage: `linear-gradient(157deg, rgba(255, 255, 255, 1) 0%, ${bgcolor} -6%, rgba(255, 255, 255, 1) 120%)`,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          className="headers-chat"
          style={{
            padding: "15px 15px 15px",
            position: "relative",
          }}
        >
          <div style={{ position: "absolute", top: 15, right: 15 }}>
            <RemoveIcon style={{ fontSize: 20, color: "#fff" }} />
          </div>
          <Tooltip placement="top" title={"Header Label"}>
            {" "}
            <h2
              style={{
                textAlign: "center",
                fontSize: 27,
                margin: "10px 0px",
                color: "white",
                width: "100%",
              }}
            >
              {headerLable}
            </h2>
          </Tooltip>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onMouseEnter={() => setnewHovered(true)}
            onMouseLeave={() => setnewHovered(false)}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "90%",
              padding: "10px 10px",
              paddingBottom: 10,
              borderRadius: 10,
              backgroundColor: newHovered ? bgcolor : "#f2f2f2",
              transition: "all ease-in-out 0.15s",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: newHovered ? "#ffffff" : bgcolor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  marginRight: 10,
                  transition: "all ease-in-out 0.15s",
                }}
              >
                <MdChat
                  style={{
                    marginTop: 2,
                    transition: "all ease-in-out 0.15s",
                  }}
                  color={newHovered ? bgcolor : "#ffffff"}
                  size={17}
                />
              </div>
              <div>
                <p
                  style={{
                    fontSize: "13px",
                    margin: "0px",
                    transition: "all ease-in-out 0.15s",
                    color: newHovered ? "#ffffff" : "#000000",
                  }}
                >
                  New Conversation
                </p>

                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "normal",
                    transition: "all ease-in-out 0.15s",
                    color: newHovered ? "#ffffff" : "#000000",
                  }}
                >
                  We typically reply in a few minutes
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                flexDirection: "column",
              }}
            >
              <IoIosArrowRoundForward
                style={{ transition: "all ease-in-out 0.15s" }}
                color={newHovered ? "#ffffff" : bgcolor}
                size={21}
              />
            </div>
          </div>
        </div>

        <div
          style={{
            padding: "10px",
            borderTop: "1px solid #eee",
            display: "flex",
            justifyContent: "space-around",
            position: "absolute",
            width: "100%",
            bottom: 0,
          }}
        >
          <div
            style={{
              padding: "10px 5px 5px 5px",
              borderBottom: `2px solid ${bgcolor}`,
              cursor: "pointer",
            }}
          >
            <IoHomeOutline color={bgcolor} size={22} />
          </div>
          <div
            style={{
              padding: "10px 5px 5px 5px",
              cursor: "pointer",
            }}
          >
            <BsChatLeftText color={bgcolor} size={22} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandDiv;
